<template>
  <v-card elevation="3">
    <v-data-table
      :headers="headers"
      :items="itens"
      :loading="carregando"
      no-data-text="Sem dados"
      loading-text="Carregando..."
      class="elevation-1"
      :footer-props="{
        'items-per-page-text': 'itens por página',
      }"
      >
      <template v-slot:item.ambienteConfigurado="{ item }">
        <v-tooltip bottom v-if="!item.ambienteConfigurado">
          <template v-slot:activator="{ on }">
          <v-icon  
          class="icon-center" 
          v-on="on"
          style="color: red;">mdi-alert</v-icon>
          </template>
          Nenhuma configuração foi implementada para esse cliente 
        </v-tooltip>

        <v-tooltip bottom v-else>
          <template  v-slot:activator="{ on }">
            <v-icon  
            v-on="on"
            class="icon-center" 
            style="color: green;">mdi-checkbox-marked-circle-outline</v-icon>
          </template>
        Configuração criada criada com sucesso
        </v-tooltip>
      </template>

      <template v-slot:item.status="{ item }" v-if="$route.name == 'Clientes'">
        <p class="pt-3" style="color: green;" v-if="item.status === true">Ativo</p>
        <p class="pt-3" style="color: red;" v-else>Inativo</p>
      </template>

      <template v-slot:item.status=" { item } " v-else>
        <span>{{item.status}}</span>
      </template>

      <template v-slot:item.acao="{ item }">
        <div class="container-icones">
        <span v-if="$route.name == 'Clientes'">
          <v-icon class="mr-1" @click="irParaUsuario(item.id)">mdi-account</v-icon>
          <v-icon class="mr-1" @click="irParaConfiguracoes(item.id)">mdi-cog</v-icon>
        </span>

          <v-icon class="mr-1" @click="ativarAcao(item, 'editar')">mdi-pencil</v-icon>
          <div class="icon-trash">
            <v-icon
              v-if="item.email != usuarioLogado.email"
              @click="ativarAcao(item, 'deletar')"
            >mdi-delete</v-icon>
          </div>
          </div>
      </template>
      <template v-slot:item.execucao="{ item }">
        <span>{{formatarData(item.execucao)}}</span>
      </template>
      <template v-slot:item.vencimento="{ item }">
        <span>{{formatarData(item.vencimento)}}</span>
      </template>
       <template v-slot:header.nomeDoCliente="{ header }">
         <span v-if="usuarioLogado.cliente == null">{{header.text}}</span>
      </template>
      <template v-slot:item.nomeDoCliente=" { item } ">
        <span v-if="usuarioLogado.cliente == null">{{item.nomeDoCliente}}</span>
      </template>
            <template v-slot:item.nomeDaOrgOuGrupo=" { item } ">
        <span>{{item.nomeDaOrgOuGrupo}}</span>
      </template>

      <template #footer.page-text="props">
        {{props.pageStart}}-{{props.pageStop}} de {{props.itemsLength}}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from "moment";

export default {
  props: {
    headers: {
      default: []
    },
    itens: {
      default: []
    },
    carregando: {
      default: false
    }
  },
  methods: {
    ativarAcao(item, tipo) {
      this.$emit(tipo, item);
    },
    irParaUsuario(usuario) {
      const formatarUrlUsuario = `/usuarios?id=${usuario}`;
      this.$router.push(formatarUrlUsuario);
    },
    irParaConfiguracoes(cliente) {
      const formatarUrlParaConfiguracao = `/configuracoes?id=${cliente}`;
      this.$router.push(formatarUrlParaConfiguracao);
    },
    formatarData(data){
      return moment(data).format("DD/MM/YYYY");
    }
  },
  computed: {
    usuarioLogado() {
      return JSON.parse(localStorage.getItem("usuarioLogado"));
    },
  }
};
</script>

<style lang="css">
.icon-center {
  text-align: left;
  position: relative;
  left: 22px;
}

.icon-trash{
  width: 24px!important;
}
.container-icones{
    display: flex;
    justify-content: center;
}
</style>